import { render, staticRenderFns } from "./BundleSelect.vue?vue&type=template&id=4f2b41c4"
import script from "./BundleSelect.vue?vue&type=script&lang=ts"
export * from "./BundleSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports